module.exports = __webpack_public_path__ + "img/tag.1c84bdb7.svg";